import React, { Component } from 'react';
import language from '../../assets/languages/language';
import App_data from '../config/App_data';

class ValidateSaveReportIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      all_questions,
      _getResult,
      _saveQuestion,
      _displayReportForm,
      bookmarkCSS,
      bookmarkColor,
      save_text,
      isQue,
      _saveNotesstats,
      saveNotes_text,
      markColor,
      isSpecialQuestion,
      showResult,
      clicked,
    } = this.props;
    // console.log('props', this.props);
    return (
      <div
        className={
          isQue ? 'col-lg-6 col-md-12 d-flex align-items-center' : 'col-sm-12 col-md-12 d-flex'
        }
      >
        {clicked || isQue ? (
          <button
            type='button'
            className={`btn btn-primary pointer_class margin_right_10 ${showResult && 'cursor_not_Allowed'}`}
            onClick={_getResult.bind(this, all_questions)}
            style={{ height: '38px' }}
            disabled={this.props.disabled || showResult}
          >
            {' '}
            {language.LC().VALIDATE}
          </button>
        ) : (
          <span className='up tooltip-hover-questions '>
            <div className='tootip_box'> {save_text} </div>
            <i
              onClick={_saveNotesstats.bind(this, all_questions)}
              className='fa fa-check mark-action-btn'
              aria-hidden='true'
              style={{ backgroundColor: `${markColor}` }}
            />
          </span>
        )}
        {isSpecialQuestion !== true ? (
          <span className='up tooltip-hover-questions' style={{ marginRight: '10px' }}>
            <div className='tootip_box'> {isQue ? save_text : saveNotes_text} </div>
            <i
              onClick={_saveQuestion.bind(this, all_questions)}
              className={bookmarkCSS}
              style={{ color: bookmarkColor }}
            >
              {' '}
            </i>
          </span>
        ) : null}
        {isSpecialQuestion !== true ? (
          <span className='up tooltip-hover-questions vertical-align-middle'>
            <div className='tootip_box'> {language.LC().REPORT_THIS_QUESTION} </div>
            <div
              className='report-icon-wrapper'
              onClick={_displayReportForm.bind(this, all_questions)}
            >
              <img src={`${App_data.frontend_url  }/img/report4.png`} alt='report' />
            </div>
          </span>
        ) : null}
      </div>
    );
  }
}

export default ValidateSaveReportIcon;



// WEBPACK FOOTER //
// ./src/views/Common/ValidateSaveReportIcon.js